// @owners { team: patient-fulfillment }
import { type Address } from '~shared/types';

export default function getAddressPlaceholder(
  address: Address | null | undefined,
  facility_id: number | null | undefined,
): string | null | undefined {
  return address && facility_id ? [address.city, address.state].join(', ') : undefined;
}
